module.exports = __webpack_public_path__ + "static/img/header-icon.676165a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/header-icon.jpg
// module id = KRLJ
// module chunks = 69